import styled from 'styled-components';

import { Text as TextLayoutComponent, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  padding: 54px 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ContainerError = styled.div`
  padding: 60px 0 0;
  align-items: center;
  justify-content: flex;
`;

export const DetailsContainer = styled.div`
  background-color: white;
  padding: 12px;
`;

export const ErrorMessage = styled(TextLayoutComponent)`
  text-align: center;
`;

export const Loader = styled(LoaderLayoutComponent)`
  align-self: center;

  &&&:last-child {
    margin-top: 20px;
  }
`;

export const Text = styled(TextLayoutComponent)``;

export const BlackComponent = styled.div`
  align-items: center;
  background: black;
  color: #F5F5F5;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 600;
  height: 100%;
  justify-content: center;
`;

export const VideoContainer = styled.div`
  flex: 1;
`;
